import React, { useEffect, useState } from 'react';
import Modal from './ui/Modal';
import Btn from './ui/Btn';
import { Input } from './ui/Input';
import { clientesTenantApi } from '../api/clientes';
import { COLORS } from '../theme';

const LIMITE = 20;

export default function ClienteSearchModal({ onSelecionar, onFechar }) {
  const [busca, setBusca] = useState('');
  const [pagina, setPagina] = useState(1);
  const [clientes, setClientes] = useState([]);
  const [temMais, setTemMais] = useState(false);
  const [carregando, setCarregando] = useState(false);

  const buscar = (paginaAlvo, buscaAlvo, acumular) => {
    setCarregando(true);
    clientesTenantApi.listar({ busca: buscaAlvo, pagina: paginaAlvo, limite: LIMITE })
      .then(lista => {
        setClientes(prev => acumular ? [...prev, ...lista] : lista);
        setTemMais(lista.length === LIMITE);
      })
      .catch(() => {})
      .finally(() => setCarregando(false));
  };

  useEffect(() => {
    const t = setTimeout(() => { setPagina(1); buscar(1, busca, false); }, 300);
    return () => clearTimeout(t);
  }, [busca]); // eslint-disable-line

  const verMais = () => {
    const proxima = pagina + 1;
    setPagina(proxima);
    buscar(proxima, busca, true);
  };

  return (
    <Modal titulo="Buscar Cliente" onFechar={onFechar} largura={640}>
      <Input
        placeholder="Buscar por nome, razão social ou CNPJ/CPF..."
        value={busca}
        onChange={e => setBusca(e.target.value)}
        autoFocus
        style={{ marginBottom: 14 }}
      />

      <div style={{ display: 'flex', flexDirection: 'column', gap: 6, maxHeight: 420, overflowY: 'auto' }}>
        {clientes.map(c => (
          <div
            key={c.id}
            onClick={() => onSelecionar(c)}
            style={{
              display: 'flex', justifyContent: 'space-between', alignItems: 'center',
              padding: '10px 12px', border: `1px solid ${COLORS.border}`, borderRadius: 8, cursor: 'pointer'
            }}
            onMouseEnter={e => { e.currentTarget.style.background = COLORS.bg; }}
            onMouseLeave={e => { e.currentTarget.style.background = 'transparent'; }}
          >
            <div>
              <div style={{ fontSize: 13, fontWeight: 600, color: COLORS.text }}>{c.nome_fantasia}</div>
              <div style={{ fontSize: 12, color: COLORS.textMid }}>
                {c.cnpj_cpf ? `CNPJ/CPF: ${c.cnpj_cpf}` : 'Sem CNPJ/CPF cadastrado'}
                {c.razao_social ? ` · ${c.razao_social}` : ''}
              </div>
            </div>
          </div>
        ))}
        {!carregando && clientes.length === 0 && (
          <p style={{ fontSize: 13, color: COLORS.textMid, textAlign: 'center', padding: 20 }}>Nenhum cliente encontrado.</p>
        )}
        {carregando && clientes.length === 0 && (
          <p style={{ fontSize: 13, color: COLORS.textMid, textAlign: 'center', padding: 20 }}>Buscando...</p>
        )}
      </div>

      {temMais && (
        <div style={{ textAlign: 'center', marginTop: 12 }}>
          <Btn variante="ghost" onClick={verMais} disabled={carregando}>{carregando ? 'Carregando...' : 'Ver mais'}</Btn>
        </div>
      )}
    </Modal>
  );
}
